import { useEffect } from 'react';
import { Tooltip } from '../../../tailwindcomponents';
import ToolRegisterList from './ToolRegisterList';
import TopRow from './TopRow';
import { useQueryTab } from '../../../utils/usePersistedTab';

function ToolRegister() {
  const { tabValue, setTabValue } = useQueryTab("tab", 0);

  const onChangeTabValue = (value: number) => {
    setTabValue(value);
  }

  useEffect(() => {
    const url = new URL(window.location.href.replace("#", ""));
    const numb = url.searchParams.get("value");
    if (numb !== null) {
      setTabValue(parseInt(numb));
    }
  }, []);

  return (
    <div className="w-full">
      <div className="w-full grid grid-row grid-cols-2  gap-2">
        <Tooltip title="Press F9 to toogle" placement="bottom">
          <div className="w-full" onClick={() => setTabValue(0)}>
            <TopRow tabValue={tabValue} staticTabValue={0} text={'Tool Out'} />
          </div>
        </Tooltip>
        <Tooltip title="Press F10 to toogle" placement="bottom">
          <div className="w-full" onClick={() => setTabValue(1)} >
            <TopRow tabValue={tabValue} staticTabValue={1} text={'Tool In'} />
          </div>
        </Tooltip>
      </div>
      <div>
        <ToolRegisterList tabValue={tabValue} onChangeTabValue={(value: number) => onChangeTabValue(value)} />
      </div>
    </div>
  );
};
export default ToolRegister